// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__3YtMH","header":"MergedInvoice_header__12l-_"};